<template>
  <div :class="ns.b()">
    <span
      v-for="(part, index) in parts"
      :key="index"
      :class="{ [ns.e('highlight-text')]: part.isKeyword }"
      :style="part.isKeyword ? highlightStyle : {}"
    >
      <slot v-if="part.isKeyword" name="keyword" :text="part.text">
        {{ part.text }}
      </slot>
      <template v-else>{{ part.text }}</template>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useNamespace } from '@lit-element/hooks'
import { highlightProps } from './highlight'

defineOptions({ name: 'LtHighlight' })

const props = defineProps(highlightProps)

const ns = useNamespace('highlight')

const parts = computed(() => {
  // 创建正则表达式，匹配关键词数组中的所有关键词
  const flags = props.caseSensitive ? 'g' : 'gi'
  const keywords = props.keyword.join('|')
  const regex = new RegExp(`(${keywords})`, flags)

  // 将文本分割为关键词和非关键词部分
  const splitParts = props.text.split(regex).map((part: string) => ({
    text: part,
    isKeyword: regex.test(part),
  }))

  const mergedParts: { text: string; isKeyword: boolean }[] = []
  let currentPart: { text: string; isKeyword: boolean } | null = null
  // 合并连续的关键词或非关键词部分
  for (const part of splitParts) {
    if (currentPart === null) {
      currentPart = part
    } else if (currentPart.isKeyword === part.isKeyword) {
      currentPart.text += part.text
    } else {
      mergedParts.push(currentPart)
      currentPart = part
    }
  }

  if (currentPart !== null) {
    mergedParts.push(currentPart)
  }

  return mergedParts
})
</script>
